import { Injectable } from '@angular/core';
import { DELETABLE_LOCAL_STORAGE_ELEMENTS, ALL_LOCAL_STORAGE_ELEMENTS } from '../constants/storage-elements';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  constructor() { }

  addElement(data: any, key: string): void {
    localStorage.setItem(key, JSON.stringify(data));
  }

  getElement(key: string): any {
    let tmp = localStorage.getItem(key);
    if(tmp) {
      tmp = JSON.parse(tmp);
    }

    return tmp;
  }

  public setElement(key: string, obj: any, encoded?: boolean) {
    var jsonObj = JSON.stringify(obj);
    if (encoded) {
      jsonObj = btoa(jsonObj);
    }
    localStorage.setItem(key, jsonObj);
  }

  public removeElement(key: string) {
    localStorage.removeItem(key);
  }

  clearStorage(clearAll?: boolean) {
    if (clearAll) {
      ALL_LOCAL_STORAGE_ELEMENTS.forEach(el => localStorage.removeItem(el));
    } else {
      DELETABLE_LOCAL_STORAGE_ELEMENTS.forEach(el => localStorage.removeItem(el));
    }
  }
}
